import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'test-pipe-2', 'TestPipe2', [["path",{"d":"M15 3v15a3 3 0 0 1 -6 0v-15"}],["path",{"d":"M9 12h6"}],["path",{"d":"M8 3h8"}]]);